export default __webpack_public_path__ + "static/media/R_wdt_c_cap_5.88660c31.mp3";